import { setEvent } from '@stores/event';
import { ICoreConfig } from 'interfaces/core-config';
import {
  createContext,
  ReactNode,
  useMemo,
  useContext,
  useEffect,
} from 'react';
import { useDispatch } from 'react-redux';

export const CoreConfigContext = createContext<ICoreConfig['food'] | undefined>(
  undefined,
);

type CoreConfigProviderProps = {
  children: ReactNode;
  config: ICoreConfig['food'];
};

export const useCoreConfig = () => {
  const context = useContext(CoreConfigContext);
  if (!context) {
    throw new Error(
      'useCoreConfigContext must be used within a CoreConfigProvider',
    );
  }

  return { ...context };
};

export const ConfigProvider = ({
  children,
  config,
}: CoreConfigProviderProps) => {
  const value = useMemo(() => ({ ...config }), []);
  const dispatch = useDispatch();

  useEffect(() => {
    if (config) {
      dispatch(
        setEvent({
          discountRate: config.discountRate,
          discountConstant: config.discountConstant,
        }),
      );
    }
  }, []);
  if (!value) return <></>;

  return (
    <CoreConfigContext.Provider value={value}>
      {children}
    </CoreConfigContext.Provider>
  );
};
